import { render, staticRenderFns } from "./InstrumentResource.vue?vue&type=template&id=14fadd54&scoped=true"
import script from "./InstrumentResource.vue?vue&type=script&lang=js"
export * from "./InstrumentResource.vue?vue&type=script&lang=js"
import style0 from "./InstrumentResource.vue?vue&type=style&index=0&id=14fadd54&prod&lang=scss&scoped=true"
import style1 from "./InstrumentResource.vue?vue&type=style&index=1&id=14fadd54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fadd54",
  null
  
)

export default component.exports